export const SITE_PREVIEW_KEY = 'rayan_site_chat_preview';

export const readSitePreview = () => {
	try {
		const params = new URLSearchParams(window.location.search);
		if (params.get('chat') === '1') {
			localStorage.setItem(SITE_PREVIEW_KEY, '1');
			params.delete('chat');
			const query = params.toString();
			const next = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
			window.history.replaceState({}, '', next);
			return true;
		}
		return localStorage.getItem(SITE_PREVIEW_KEY) === '1';
	} catch (e) {
		return false;
	}
};
